import { render, staticRenderFns } from "./DistrictDetails.vue?vue&type=template&id=787f1fce"
import script from "./DistrictDetails.vue?vue&type=script&lang=js"
export * from "./DistrictDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports